// extracted by mini-css-extract-plugin
module.exports = {"gradientPlaceholder":"GradientPlaceholder_gradientPlaceholder__KiXj9","loading":"GradientPlaceholder_loading__281v8"};